import React from 'react'
import FactsBgImage from '../../../images/public/34.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserDoctor,faHospital, faTooth } from '@fortawesome/free-solid-svg-icons'
import CountUp from '../../../components/countup'

const Facts = () => {
  return (
    <div className='public_home_facts_background' style={{backgroundImage:`url(${FactsBgImage})`}}>
      <div className='public_home_facts_wrapper'>
        <div className='public_home_facts_container'>
            <div className='public_home_facts_title'>
                <span className='public_home_section_eyebrow public_home_section_eyebrow_light'>BY THE NUMBERS</span>
                <h3 className='colorprimary'>You Are Important To Us</h3>
                <p>At N Vision Digital Dental Laboratory, we provide unparalleled dental restorations at the most affordable prices. "Your patients are our priority". We strive to build lasting relationships with dental professionals through quality products and excellent customer services.</p>
            </div>
            <div className='public_home_facts_items'>
                <div className='public_home_facts_item'>
                    <div className='public_home_facts_item_image'>
                        <FontAwesomeIcon icon={faUserDoctor} />
                    </div>
                    <div className='public_home_facts_item_about'>
                        <h2><CountUp end={500} suffix='+'/></h2>
                        <h3>Dentists</h3>
                    </div>
                </div>
                <div className='public_home_facts_item'>
                    <div className='public_home_facts_item_image'>
                        <FontAwesomeIcon icon={faHospital} />
                    </div>
                    <div className='public_home_facts_item_about'>
                        <h2><CountUp end={70} suffix='+'/></h2>
                        <h3>Clinics</h3>
                    </div>
                </div>
                <div className='public_home_facts_item'>
                    <div className='public_home_facts_item_image'>
                        <FontAwesomeIcon icon={faTooth} />
                    </div>
                    <div className='public_home_facts_item_about'>
                        <h2><CountUp end={20000} suffix='+'/></h2>
                        <h3>Cases</h3>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default Facts
